import type { MessageTree, MessageVars } from './types';

function lookup(tree: MessageTree, key: string): string | undefined {
  const parts = key.split('.');
  let current: string | MessageTree | undefined = tree;
  for (const part of parts) {
    if (current === undefined || typeof current === 'string') {
      return undefined;
    }
    current = current[part];
  }
  return typeof current === 'string' ? current : undefined;
}

export function interpolate(template: string, vars?: MessageVars): string {
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) => (
    vars[name] !== undefined ? String(vars[name]) : match
  ));
}

export function translate(
  localeMessages: MessageTree,
  fallback: MessageTree,
  key: string,
  vars?: MessageVars
): string {
  const raw = lookup(localeMessages, key) ?? lookup(fallback, key) ?? key;
  return interpolate(raw, vars);
}
